"use client";

import { Spinner } from "design-system/spinner";
import { BasicLogoLayout } from "@/components/layouts/basic-logo-layout";

export function LoadingLayout({ children, isLoading = true }: { children?: React.ReactNode; isLoading?: boolean }) {
  return (
    <BasicLogoLayout>
      {isLoading && <Spinner className="size-8" />}

      <div>{children}</div>
    </BasicLogoLayout>
  );
}
